import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { CarRentalAccountSettings } from '@pulpo/pulpo-models';
import ApiService from '../api.service.abstract';
import { APP_CONFIG } from '@pulpo/app-config';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CarRentalAccountSettingsService extends ApiService<CarRentalAccountSettings> {
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient
  ) {
    super(environment, http, 'car-rental/api/car-rental-settings');
    if (environment.name === 'localDev') {
      this.url = 'http://localhost:8083';
    }
  }

  public getAll(): Observable<HttpResponse<CarRentalAccountSettings[]>> {
    return this.http.get<CarRentalAccountSettings[]>(
      `${this.url}/${this.endpoint}`,
      {
        observe: 'response',
      }
    );
  }

  public override updateAll(credentials: CarRentalAccountSettings[]) {
    return this.http.post<CarRentalAccountSettings[]>(
      `${this.url}/${this.endpoint}`,
      credentials,
      {
        observe: 'response',
      }
    );
  }
}
